import { useNavigate, useLocation } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <main className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <span className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-foreground-100 select-none pointer-events-none z-0">
        404
      </span>
      <div className="relative z-10">
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-6">
          페이지를 찾을 수 없습니다
        </h1>
        <p className="mt-2 text-sm text-foreground-500 font-mono">
          {location.pathname}
        </p>
        <p className="mt-4 text-base text-foreground-600">
          요청하신 페이지가 존재하지 않거나 이동되었습니다.
        </p>
        <button
          onClick={() => navigate("/")}
          className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 font-medium text-sm transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-3-line w-4 h-4 flex items-center justify-center"></i>
          홈으로 돌아가기
        </button>
      </div>
    </main>
  );
}